
class Utils {
  screenId = {
    waterQuality: process.env.VUE_APP_SCREEN_ID_WATER_QUALITY, // แบบบันทึกการตรวจวัดคุณภาพน้ำเบื้องต้น (Test Kit)
    waterQualitySample: process.env.VUE_APP_SCREEN_ID_WATER_QUALITY_SAMPLE, // แบบฟอร์มการส่งตัวอย่างน้ำ (Lab)
    soundMeasurement: process.env.VUE_APP_SCREEN_ID_SOUND_MEASUREMENT, // แบบบันทึกการตรวจวัดเสียง
    waterQualityResearcherAdmin: process.env.VUE_APP_SCREEN_ID_WATER_QUALITY_RESEARCHER_ADMIN, // รายละเอียด แบบตอบรับการส่งตัวอย่างน้ำ (ทีมวิจัย)
    waterQualityAdmin: process.env.VUE_APP_SCREEN_ID_WATER_QUALITY_ADMIN, // แบบบันทึกการตรวจวัดคุณภาพน้ำเบื้องต้น (Test Kit) Admin
    waterQualitySampleAdmin: process.env.VUE_APP_SCREEN_ID_WATER_QUALITY_SAMPLE_ADMIN, // แบบฟอร์มการส่งตัวอย่างน้ำ (Lab) Admin
    soundMeasurementAdmin: process.env.VUE_APP_SCREEN_ID_SOUND_MEASUREMENT_ADMIN, // แบบบันทึกการตรวจวัดเสียง Admin
    agraEnvHeavyMetalSurvey: process.env.VUE_APP_SCREEN_ID_AGRA_ENV_HEAVY_METAL_SURVEY, // แบบบันทึกการตรวจวัดโลหะหนัก (Heavy Metal)
    agraEnvHeavyMetalSurveyAdmin: process.env.VUE_APP_SCREEN_ID_AGRA_ENV_HEAVY_METAL_SURVEY_ADMIN, // แบบบันทึกการตรวจวัดโลหะหนัก (Heavy Metal) Admin
    agraEnvHeavyMetalSurveyResearcherAdmin: process.env.VUE_APP_SCREEN_ID_AGRA_ENV_HEAVY_METAL_SURVEY_RESEARCHER_ADMIN // แบบบันทึกการตรวจวัดโลหะหนัก (Heavy Metal) Researcher Admin
  };

  displayNumberFormat (number) {
    return number ? Number(number).toLocaleString('en-US') : null;
  }

  alertWarningMsg (txt, title) {
    window.Swal.fire({
      icon: 'warning',
      title: title ? title : 'แจ้งเตือน',
      text: txt,
      confirmButtonText: 'ตกลง',
      confirmButtonColor: '#1b526f'
    });
  }

  alertSuccessMsg (txt, title) {
    window.Swal.fire({
      icon: 'success',
      customClass: {
        icon: 'icon_success'
      },
      title: title ? title : 'แจ้งเตือน',
      text: txt,
      confirmButtonText: 'ตกลง',
      confirmButtonColor: '#1b526f',
    });
  }
  alertConfirmButton(txt, fn, icon = 'warning') {
    window.Swal.fire({
      title: 'แจ้งเตือน',
      text: txt,
      icon: icon,
      showCancelButton: true,
      confirmButtonText: 'ยืนยัน',
      confirmButtonColor: '#1b526f',
      cancelButtonText: 'ยกเลิก',
      cancelButtonColor: '#9b9da0',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
      fn()
      }
    });
  }

  getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  getWaterQualityStatusTextList() {
    return ['ไม่ต้องส่งตัวอย่าง', 'เก็บตัวอย่างส่งนักวิจัย', 'เก็บตัวอย่างส่งนักวิจัยแล้ว', 'อยู่ระหว่างรอผลตรวจ', 'ตอบกลับผลตรวจแล้ว', 'ยกเลิก'];
  }

  getWaterQualityStatusText(status) {
    const list = this.getWaterQualityStatusTextList();
    return list[status] || '';
  }

  getWaterQualityStatusColorList() {
    return ['status-gray', 'status-danger', 'status-warning', 'status-waiting', 'status-success'];
  }

  // heavy metal survey
  getHeavyMetalStatusColorList() {
    return ['status-warning', 'status-waiting', 'status-success'];
  }

  getHeavyMetalStatusTextList() {
    return ['อยู่ระหว่างตรวจสอบข้อมูล', 'รอผลตรวจ', 'ตอบกลับผลตรวจแล้ว'];
  }

  getHeavyMetalStatusTextResearcherList () {
    return [
      { text: 'รออนุมัติส่งตรวจ', value: 1 },
      { text: 'อนุมัติส่งตรวจ', value: 2 },
      { text: 'แจ้งผลตรวจ', value: 3 },
      { text: 'ยกเลิก', value: 99 }
    ];
  }

  setNumberFormat(value) {
    if (value === '' || value === null || value === undefined) {
      return '-';
    }
    const num = parseFloat(value);
    if (isNaN(num)) {
      return value;
    }
    return num.toFixed(4);
  }
}

export default new Utils();
